import React from "react";
import * as R from "ramda";
import {connect} from "react-redux";
import {Form} from "react-final-form";
import {
  consultarSolicitud,
  consultarTiposSolicitud,
  limpiarEstadoBusquedaSolicitud
} from "../../redux/modules/busquedaSolicitud/actions";
import Dialog from "../../components/UI/Dialog/Dialog";
import SeleccionarProcesoForm from "./SeleccionarProcesoForm";
import {REQUEST} from "../../util/Request";
import {URLs} from "../../util/Constants";
import {ValidationUtils} from "../../util/ValidationUtils";
import {BuscarSolicitudRequest} from "../../request/BuscarSolicitudRequest/BuscarSolicitudRequest";
import withRecaptcha from "../../hoc/WithRecaptcha";

export class SeleccionarProcesoSinConectar extends React.PureComponent<any, any> {

  tempFormData: any;

  constructor(props: any) {
    super(props);
    this.state = {
      showDialogNoResultsFound: false,
      showDialogSolicitudFinalizada: false,
      showDialogSolicitudCancelada: false,
      showDialogSolicitudRecibiendoInternet: false,
      showDialogErrorGenerico: false,
      codigoAsesoria: "",
      tipoProceso: "",
      tipoIdentificacion: "",
      numeroIdentificacion: ""
    };
    this.closeDialogs = this.closeDialogs.bind(this);
  }

  componentWillMount(): void {
    this.props.dispatch(limpiarEstadoBusquedaSolicitud());
    if (this.props.location !== undefined && this.props.location.search) {
      this.preloadFields();
    }
  }

  preloadFields(): void {
    const query = new URLSearchParams(this.props.location.search);
    const codigoAsesoria = query.get("id_asesoria");
    const tipoProceso = (query.get("tipo_proceso") === undefined) ? "": query.get("tipo_proceso");
    const numeroIdentificacion = query.get("numero_identificacion");
    const tipoIdentificacion = (query.get("tipo_identificacion") === undefined) ? "": query.get("tipo_identificacion");

    this.setState({
      codigoAsesoria,
      tipoProceso,
      tipoIdentificacion,
      numeroIdentificacion
    });
  }

  componentDidMount(): void {
    this.props.dispatch(consultarTiposSolicitud());
  }

  componentWillReceiveProps(nextProps: any) {
    if (nextProps.estadoConsultarSolicitud === REQUEST.SUCCESS) {
      this.validarEstadoSolicitud(nextProps);
    } else if (nextProps.estadoConsultarSolicitud === REQUEST.ERROR) {
      if (nextProps.errorConsultarSolicitud.status === 404) {
        this.setState({showDialogNoResultsFound: true});
      } else {
        this.setState({showDialogErrorGenerico: true});
      }
    } else if (nextProps.estadoConsultarTiposSolicitud === REQUEST.ERROR) {
      this.setState({showDialogErrorGenerico: true});
    }
  }

  render() {

    return (
      <div className="container-fluid">
        <Form onSubmit={this.validateCaptcha}
              validate={this.validateForm}
              initialValues={{
                tipoProceso: this.state.tipoProceso.toUpperCase(),
                numeroIdentificacion:this.state.numeroIdentificacion,
                tipoIdentificacion: this.state.tipoIdentificacion.toUpperCase(),
                codigoAsesoria: this.state.codigoAsesoria
              }}
              render={(finalFormProps) => {
                return (
                  <>

                    <SeleccionarProcesoForm
                      {...finalFormProps}
                      tiposSolicitud={this.props.tiposSolicitud}
                      disabled={this.isSubmitButtonDisabled(finalFormProps.errors)}
                      loader={this.isLoading()}/>

                  </>
                );
              }}
        />

        {this.state.showDialogNoResultsFound &&
        <Dialog id="spBusquedaFallidaDlg"
                title="B&uacute;squeda fallida"
                icon="alert-triangle"
                confirmBtnText="Aceptar"
                onConfirm={() => this.closeDialogs()}
                onCancel={() => this.closeDialogs()}>
          No hay un proceso activo con ese documento para el proceso elegido.
          Por favor, verifica la informaci&oacute;n o comun&iacute;cate con uno de nuestros asesores.
        </Dialog>}

        {this.state.showDialogSolicitudFinalizada &&
        <Dialog id="spDocumentacionAprobadaDlg"
                icon="check-circle"
                title="Documentación aprobada"
                confirmBtnText="Aceptar"
                onCancel={this.pushToEstadoDocumentos}
                onConfirm={this.pushToEstadoDocumentos}>
          Tus documentos han sido aprobados y tu solicitud se encuentra en proceso. 
          Si tienes alguna inquietud, comun&iacute;cate con una de nuestras l&iacute;neas de servicio:
          Bogotá 744 44 64 / Medellín y Cali 510 90 99
          Barranquilla 319 79 99 / Cartagena 642 49 99
          Resto del país desde una línea fija al 01 8000 52 8000.
        </Dialog>
        }

        {this.state.showDialogSolicitudCancelada &&
        <Dialog id="spSolicitudCanceladaDlg"
                icon="alert-triangle"
                title="Solicitud cancelada"
                confirmBtnText="Aceptar"
                onCancel={() => this.closeDialogs()}
                onConfirm={() => this.closeDialogs()}>
          La solicitud se encuentra CANCELADA. Por favor comun&iacute;cate con uno de nuestros
          asesores para iniciar nuevamente el tr&aacute;mite.
        </Dialog>
        }

        {this.state.showDialogSolicitudRecibiendoInternet &&
        <Dialog id="spSolicitudRecibiendoInternetDlg"
                icon="alert-triangle"
                title="Información"
                confirmBtnText="Aceptar"
                onCancel={() => this.closeDialogs()}
                onConfirm={() => this.closeDialogs()}>
          Esta solicitud presentó un error en la carga de documentos. Por favor intente nuevamente en unos minutos.
        </Dialog>
        }

        {this.state.showDialogErrorGenerico &&
        <Dialog id="spErrorConexionDlg"
                icon="alert-triangle"
                title="Error de conexión"
                confirmBtnText="Aceptar"
                onCancel={() => this.closeDialogs()}
                onConfirm={() => this.closeDialogs()}>
          Ocurri&oacute; un error de conexi&oacute;n. Por favor int&eacute;ntelo m&aacute;s tarde.
        </Dialog>
        }

      </div>
    );
  }

  validarEstadoSolicitud = nextProps => {
    if (nextProps.estadoSolicitud === "NUEVA") {
      this.props.history.push(URLs.CARGA_DOCUMENTAL);
    } else if (nextProps.estadoSolicitud === "EN_VALIDACION") {
      this.props.history.push(URLs.ESTADO_DOCUMENTOS);
    } else if (nextProps.estadoSolicitud === "FINALIZADA") {
      this.setState({showDialogSolicitudFinalizada: true});
    } else if (nextProps.estadoSolicitud === "CANCELADA") {
      this.setState({showDialogSolicitudCancelada: true});
    } else if (nextProps.estadoSolicitud === "RECIBIENDO_INTERNET") {
      this.setState({showDialogSolicitudRecibiendoInternet: true});
    }
  }

  validateForm = (values) => {
    const requiredFields: Array<string> = [];
    requiredFields.push("tipoProceso");
    requiredFields.push("tipoIdentificacion");
    requiredFields.push("numeroIdentificacion");
    if (values.tipoProceso === "RADICACION_VEJEZ"
      || values.tipoProceso === "RADICACION_SOBREVIVENCIA"
      || values.tipoProceso === "RADICACION_INVALIDEZ"
      || values.tipoProceso === "NOVEDADES_NOMINA_PENSIONADO") {
      requiredFields.push("codigoAsesoria");
    }
    return ValidationUtils.validateRequiredFields(requiredFields, values);
  }

  isSubmitButtonDisabled = (errors) => {
    return Object.getOwnPropertyNames(errors).length > 0 || this.isLoading();
  }

  validateCaptcha = (formData) => {
    this.tempFormData = formData;
    this.props.setOnRecaptchaSuccessFunction(this.onCaptchaSuccess);
    this.props.recaptchaValidate();
  }

  onCaptchaSuccess = recaptchaToken => {
    const request = new BuscarSolicitudRequest(
      this.tempFormData.tipoProceso,
      this.tempFormData.codigoAsesoria,
      this.tempFormData.tipoIdentificacion,
      this.tempFormData.numeroIdentificacion,
      recaptchaToken,
    );
    this.props.dispatch(consultarSolicitud(request));
  }

  isLoading = () => {
    return this.props.estadoConsultarTiposSolicitud === REQUEST.PENDING
      || this.props.estadoConsultarSolicitud === REQUEST.PENDING;
  }

  closeDialogs = () => {
    this.setState({
      showDialogNoResultsFound: false,
      showDialogSolicitudFinalizada: false,
      showDialogSolicitudCancelada: false,
      showDialogSolicitudRecibiendoInternet: false,
      showDialogErrorGenerico: false
    });
  }

  pushToEstadoDocumentos = () => {
    const {history} = this.props;
    history.push(URLs.ESTADO_DOCUMENTOS);
  }

}

const SeleccionarProceso: any = connect(
  (store: any) => {
    return {
      tiposSolicitud:
        R.pathOr([], ["recDocInternet", "solicitudes", "tiposSolicitud"], store),
      solicitud:
        R.pathOr(undefined, ["recDocInternet", "solicitudes", "solicitud"], store),
      estadoSolicitud:
        R.pathOr(undefined, ["recDocInternet", "solicitudes", "solicitud", "estado"], store),
      estadoConsultarTiposSolicitud:
        R.pathOr(REQUEST.NONE, ["recDocInternet", "solicitudes", "estadoConsultarTiposSolicitud"], store),
      estadoConsultarSolicitud:
        R.pathOr(REQUEST.NONE, ["recDocInternet", "solicitudes", "estadoConsultarSolicitud"], store),
      errorConsultarSolicitud:
        R.pathOr(undefined, ["recDocInternet", "solicitudes", "errorConsultarSolicitud"], store),
    };
  },
)(SeleccionarProcesoSinConectar);

export default withRecaptcha(SeleccionarProceso);
